import ReviewRow from "./ReviewRow";
import { ReviewDTO } from "../../../api/Reviews/GetAllReviews";
const ReviewTable = ({ data }: { data?: ReviewDTO[] }) => {
    return (
        <div className="overflow-x-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch ">
            <table className="table-auto w-full">
                <thead className="text-lg capitalize ">
                    <tr className="bg-[#F1F4F9] rounded-t-lg">
                    <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-[10%]">
                            <div className="text-left text-sm">
                                Name
                            </div>
                        </th>
                        <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-[70%]">
                            <div className="text-left text-sm">
                                Review
                            </div>
                        </th>
                        <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-[10%]">
                            <div className="text-left text-sm">
                                Rating
                            </div>
                        </th>
                        <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-[10%]">
                            <div className="text-left text-sm sr-only">
                                
                            </div>
                        </th>

                    </tr>
                </thead>
                <tbody className="text-sm">
                    {data?.map((review: ReviewDTO) => (
                        <ReviewRow
                            key={review.id}
                            name={review.name}
                            review={review.review}
                            rating={review.rating}
                            reviewId={review.id}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ReviewTable;
